import * as _ from 'lodash';
import { IContact } from '@nkr/models/index';
import { OpsScheduleStatus } from '@nkr/enums/index';
import { IOpsScheduleWithValidation } from './ops-schedule-wih-validation';
import { FormEvent } from 'react';
import { FormControl, FormGroup, Glyphicon } from 'react-bootstrap';
import { Icon } from 'react-icons-kit';
import { androidColorPalette } from 'react-icons-kit/ionicons/androidColorPalette';
import MaskedInput from 'react-maskedinput';

interface IProps {
    data: IOpsScheduleWithValidation,
    count: number,
    dirty: boolean,
    staffList: IContact[],
    onEmployeeChange: (scheduleId: number, employeeId: number) => void,
    onStartTimeChange: (scheduleId: number, dayId: number, startTime: string) => void,
    onEndTimeChange: (scheduleId: number, dayId: number, startTime: string) => void,
    onPickColor: (scheduleId: number) => void,
    onToggleDelete: (scheduleId: number, status: OpsScheduleStatus) => void,
    onMoveUp: (scheduleId: number) => void,
    onMoveDown: (scheduleId: number) => void
}

const EditRow = (props: IProps) => {
    const handlePickColor = () => {
        props.onPickColor(props.data.id);
    }

    const handleEmployeeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onEmployeeChange(props.data.id, parseInt(e.currentTarget.value));
    }

    const handleStartTimeChange = (dayId: number, startTime: string) => {
        props.onStartTimeChange(props.data.id, dayId, startTime);
    }

    const handleEndTimeChange = (dayId: number, endTime: string) => {
        props.onEndTimeChange(props.data.id, dayId, endTime);
    }

    const sortedDays = _.sortBy(props.data.days, x => x.displayOrder);

    return (
        <tr>
            <td style={{ backgroundColor: props.data.backgroundColor }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && props.data.validEmployee == false ? 'error' : null}>
                        <FormControl
                            componentClass='select'
                            bsSize='xs'
                            value={props.data.employeeId}
                            onChange={handleEmployeeChange}
                        >
                            <option value={0}>- Select -</option>
                            {props.staffList.map(item =>
                                <option key={'emp-' + item.id} value={item.id}>{item.firstName}</option>
                            )}
                        </FormControl>
                    </FormGroup>
                    <div style={{ paddingLeft: 5, color: props.data.color }} title='Select color...' onClick={handlePickColor}><Icon icon={androidColorPalette} /></div>
                </div>
            </td>
            {sortedDays.map(day =>
                <>
                    <td>
                        <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && day.validStartTime == false ? 'error' : null}>
                            <MaskedInput
                                className='form-control'
                                mask='11:11'
                                placeholder='HH:MM'
                                style={{ borderColor: props.dirty && day.validStartTime == false ? '#a94442' : null }}
                                value={day.startTime}
                                onChange={(e: FormEvent<FormControl & HTMLInputElement>) => handleStartTimeChange(day.id, e.currentTarget.value)}
                            />
                        </FormGroup>
                    </td>
                    <td>
                        <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && day.validEndTime == false ? 'error' : null}>
                            <MaskedInput
                                className='form-control'
                                mask='11:11'
                                placeholder='HH:MM'
                                style={{ borderColor: props.dirty && day.validEndTime == false ? '#a94442' : null }}
                                value={day.endTime}
                                onChange={(e: FormEvent<FormControl & HTMLInputElement>) => handleEndTimeChange(day.id, e.currentTarget.value)}
                            />
                        </FormGroup>
                    </td>
                </>
            )}
            <td>
                {props.data.displayOrder > 0 && (
                    <span title='Move up'><Glyphicon glyph='arrow-up' onClick={() => props.onMoveUp(props.data.id)} /></span>
                )}

                {props.data.displayOrder < props.count - 1 && (
                    <span title='Move down'><Glyphicon glyph='arrow-down' onClick={() => props.onMoveDown(props.data.id)} /></span>
                )}

                {props.data.status == OpsScheduleStatus.Deleted ?
                    <span title='Will be deleted upon save'>
                        <Glyphicon glyph='trash' onClick={() => props.onToggleDelete(props.data.id, OpsScheduleStatus.Included)} />
                    </span>
                    :
                    <span title='Will be included upon save'>
                        <Glyphicon glyph='ok' onClick={() => props.onToggleDelete(props.data.id, OpsScheduleStatus.Deleted)} />
                    </span>
                }
            </td>
        </tr>
    );
}

export default EditRow;